(() => {
  const SELECTOR = '[data-product-card-window-badge]';
  const badges = new Set();
  let intervalId = null;

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function formatCountdown(milliseconds) {
    const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const parts = [];

    if (days > 0) parts.push(`${days}D`);
    parts.push(`${pad(hours)}H`, `${pad(minutes)}M`, `${pad(seconds)}S`);

    return parts.join(' ');
  }

  function updateBadge(badge, now = Date.now()) {
    if (!badge.isConnected) {
      badges.delete(badge);
      return;
    }

    const label = badge.querySelector('[data-product-card-window-label]');
    const countdown = badge.querySelector('[data-product-card-window-countdown]');
    const start = Number(badge.dataset.windowStartTimestamp);
    const end = Number(badge.dataset.windowEndTimestamp);

    if (!label || !countdown || Number.isNaN(start) || Number.isNaN(end)) {
      badge.hidden = true;
      badges.delete(badge);
      return;
    }

    if (now < start) {
      badge.hidden = false;
      label.textContent = badge.dataset.labelBefore ?? '';
      countdown.textContent = formatCountdown(start - now);
      return;
    }

    if (now < end) {
      badge.hidden = false;
      label.textContent = badge.dataset.labelDuring ?? '';
      countdown.textContent = formatCountdown(end - now);
      return;
    }

    if (badge.dataset.hideAfterClose === 'true') {
      badge.hidden = true;
      badges.delete(badge);
      return;
    }

    badge.hidden = false;
    label.textContent = badge.dataset.labelAfter ?? '';
    countdown.textContent = '';
    badges.delete(badge);
  }

  function initializeBadge(badge) {
    if (!(badge instanceof HTMLElement) || badge.dataset.timerInitialized === 'true') return;

    const start = Number(badge.dataset.windowStart) * 1000;
    const end = Number(badge.dataset.windowEnd) * 1000;

    if (!Number.isFinite(start) || !Number.isFinite(end)) {
      badge.hidden = true;
      return;
    }

    badge.dataset.timerInitialized = 'true';
    badge.dataset.windowStartTimestamp = String(start);
    badge.dataset.windowEndTimestamp = String(end);
    badges.add(badge);
    updateBadge(badge);
    ensureInterval();
  }

  function initializeWithin(root = document) {
    if (root instanceof Element && root.matches(SELECTOR)) {
      initializeBadge(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(SELECTOR).forEach(initializeBadge);
    }
  }

  function updateAll() {
    const now = Date.now();
    badges.forEach((badge) => updateBadge(badge, now));

    if (badges.size === 0 && intervalId !== null) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  }

  function ensureInterval() {
    if (intervalId === null && badges.size > 0) {
      intervalId = window.setInterval(updateAll, 1000);
    }
  }

  function startObserver() {
    if (!document.body || window.__productCardWindowBadgeObserver) return;

    window.__productCardWindowBadgeObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) initializeWithin(node);
        });
      });
    });

    window.__productCardWindowBadgeObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function boot() {
    initializeWithin(document);
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeWithin(event.target);
  });
})();